exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-state-design-inline .state-inline-display.state-inline-display--navi .fts-state{transition:transform .2s linear;cursor:pointer}.fts-state-design-inline .state-inline-display.state-inline-display--navi .fts-state:hover{transform:scale(1.075)}.fts-state-design-inline .state-inline-display .state-inline-display-tippy{min-width:0}.fts-state-design-inline .state-inline-display .fts-state{min-width:3.5rem}.fts-state-design-inline .state-inline-display .fts-state>div{flex:1;font-size:1rem;text-align:center}", ""]);

// exports
